import { Fragment } from 'react/jsx-runtime'
import { DAYS_OF_WEEK, type MealType } from '../../../utils/calendarUtils'

import '../Calendar/Meal.scss'
import type { recipe } from '../../../utils/recipeUtils'
import type { ExtraButton } from '../../PopupForm/Popup'
import { capitalizeFirstLetter } from '../../../utils/stringUtils'
import { getMessage } from '../../../utils/messageUtils'
import TemplatePopupContent from './TemplatePopupContent'

interface TemplateMealProps {
  recipeId: number | null | undefined
  type: MealType
  date: number
  existingRecipes: recipe[] | undefined
  isMobile: boolean
  openPopup: (
    message: string,
    children: React.ReactNode,
    extraButtons: ExtraButton[]
  ) => void
  closePopup: () => void
  setPopupOnOk: React.Dispatch<React.SetStateAction<() => void>>
  updateCurrentTemplate: (
    day: number,
    mealType: MealType,
    recipeId: number | null
  ) => void
}

function TemplateMeal({
  recipeId,
  type,
  date,
  existingRecipes,
  isMobile,
  openPopup,
  closePopup,
  setPopupOnOk,
  updateCurrentTemplate,
}: TemplateMealProps) {
  const handleExtraButton = (value: number) => {
    updateCurrentTemplate(date, type, value)
    closePopup()
  }
  const storeRecipe = async (newRecipeId: number) => {
    updateCurrentTemplate(date, type, newRecipeId)
  }
  const handleDelete = () => {
    updateCurrentTemplate(date, type, null)
    closePopup()
  }

  const handleClick = () => {
    openPopup(
      `${capitalizeFirstLetter(type)} ${getMessage('for')} ${DAYS_OF_WEEK[date]}`,
      <TemplatePopupContent
        recipeId={recipeId}
        type={type}
        existingRecipes={existingRecipes}
        setPopupOnOk={setPopupOnOk}
        storeRecipe={storeRecipe}
        closePopup={closePopup}
      />,
      [
        {
          label: getMessage('question_mark'),
          className: 'calendar-popup-question-button',
          onClick: () => handleExtraButton(-1),
        },
        {
          label: getMessage('x_mark'),
          className: 'calendar-popup-x-button',
          onClick: () => handleExtraButton(0),
        },
        {
          label: getMessage('delete'),
          className: 'calendar-popup-delete-button',
          onClick: () => handleDelete(),
        },
      ] as ExtraButton[]
    )
  }

  const classNameSpecial =
    recipeId !== null && recipeId === 0
      ? ' calendar-box-empty'
      : recipeId !== null && recipeId === -1
        ? 'calendar-box-question'
        : ''

  const recipe = existingRecipes?.find(r => r.id === recipeId) || null
  const recipeName =
    !recipe || (recipeId !== null && (recipeId === 0 || recipeId === -1))
      ? ''
      : recipe?.name

  if (!setPopupOnOk) return
  return (
    <Fragment>
      <div
        className={`calendar-box calendar-box-${type} ${isMobile ? 'calendar-box-mobile' : ''}  ${classNameSpecial}`}
        onClick={handleClick}
      >
        {recipeName}
      </div>
    </Fragment>
  )
}

export default TemplateMeal
